import { Button, Typography } from "antd";
import { SvgIcon } from "assets/icons";
import CustomModal from "components/CustomModal";
import { useConfirmApproveCheckQualityPurchaseOrder } from "hooks/purchase";
import { t } from "i18next";
import { useState } from "react";
import { notify } from "utils/helperFuncs";
import "./index.scss";

export const ButtonAccept = ({ record }) => {
  const [visible, setVisible] = useState(false);

  const showModal = () => {
    setVisible(true);
  };
  const handleCancel = () => {
    setVisible(false);
  };

  const { handleConfirmApproveCheckQualityPurchaseOrder, loading } = useConfirmApproveCheckQualityPurchaseOrder();

  const onConfirm = async () => {
    try {
      await handleConfirmApproveCheckQualityPurchaseOrder([record?.id])
        .then(() => {
          setVisible(false);
          notify.success({
            message: t("purchase.buttonGroup.confirmAcceptMessageSuccess"),
          });
        })
        .catch((error) => {
          notify.error({
            message: error.message,
          });
        });
    } catch (error) {
      notify.error({
        message: error.message,
      });
    }
  };

  return (
    <div>
      <CustomModal
        {...{
          width: "30%",
          customComponent: (
            <Button type="primary" loading={loading}>
              {t("warehouse.recommendImport.accept")}
            </Button>
          ),
          footer: false,
          centered: true,
          styleButton: "notButton",
          hideConfirmButton: true,
          className: "form-accept-purchase-order",
          addMoreButton: (
            <div className="button-group-action-accept-purchase-order">
              <Button type="secondary" htmlType="submit" onClick={handleCancel} loading={loading}>
                {t("productBrand.cancel")}
              </Button>
              <Button type="primary" htmlType="submit" onClick={onConfirm} loading={loading}>
                {t("common.confirm")}
              </Button>
            </div>
          ),
          visible: visible,
          onOpen: showModal,
          onCancel: handleCancel,
          hideCancelButton: true,
        }}
      >
        <div className="form-accept-content">
          <SvgIcon.IconInfoConfirm />
          <div>
            <Typography.Text>{t("purchase.buttonGroup.confirmAcceptMessage")} </Typography.Text>
            <Typography.Link strong>{record?.code}</Typography.Link>?
          </div>
        </div>
      </CustomModal>
    </div>
  );
};
